import { FormatDestinationsReturn, FormatModelsReturn } from './model';

const formatDestinations = (destinations): FormatDestinationsReturn[] =>
  destinations.map((destination) => {
    const { name, provider } = destination;
    return {
      name,
      provider: provider ?? '',
      logo: `/assets/connector-icons/rounded-logos/${provider}-rounded.svg`,
    };
  });

export const formatModels = (models): FormatModelsReturn[] =>
  models.map((model) => {
    const {
      name,
      provider,
      createdAt,
      publishedTables,
      destinations,
      statusObject,
    } = model;

    const formattedDestinations = formatDestinations(destinations);

    return {
      name,
      provider: provider ?? '',
      createdAt,
      publishedTables,
      destinations: formattedDestinations,
      status: statusObject?.status,
    };
  });
